module.exports = __webpack_public_path__ + "img/LP_Full_Green.412273f3.svg";